import { AgColDefsI, AgGridI, } from "../../../../shared/components/ag-grid/ag-grid.model";
import { RatingComponent } from "src/app/shared/components/ag-grid/rating/rating.component";
import { DocumentCellRendererComponent } from "src/app/components/crm/companies/pages/company-info-tabs/document-cell-renderer/document-cell-renderer.component";


const commonColumnProperties = {
  suppressMovable: true,
  flex: 1,
  editable : false,
}

const commonProperties100Width = {
  ...commonColumnProperties,
  sortable: true,
  minWidth: 100,
  cellStyle: { 'padding-left': "22px", 'color': '#646E76' },
  cellRenderer: (params: any) => params.value ? params.value : "&#8212",
}

const commonProperties150Width = {
  ...commonColumnProperties,
  sortable: true,
  minWidth: 150,
  cellStyle: { 'padding-left': "22px", 'color': '#646E76' },
  cellRenderer: (params: any) => params.value ? params.value : "&#8212",
}

const commonProperties200Width = {
  ...commonColumnProperties,
  sortable: true,
  minWidth: 200,
  cellStyle: { 'padding-left': "22px", 'color': '#646E76' },
  cellRenderer: (params: any) => params.value ? params.value : "&#8212",
}

const commonPrimaryColorColumnProperties = {
  ...commonColumnProperties,
  sortable: true,
  minWidth: 200,
  cellStyle: { 'color': 'var(--sitewide_primary_accent_color)', 'padding-left': "22px" },
  cellRenderer: (params: any) => params.value ? params.value : "&#8212",
}

const svgColumn: AgColDefsI = {
  headerName: "",
  field: "svgSuccess",
  minWidth: 100,
  width: 100,
  suppressMovable: true,
  flex: 1,
  cellRenderer: DocumentCellRendererComponent,
};

const RatingColumn: AgColDefsI = {
  ...commonColumnProperties,
  headerName: "Rating",
  field: "companyRating",
  minWidth: 150,
  sortable: true,
  cellStyle: { 'padding-left': "22px" },
  cellRenderer: RatingComponent,
};

const SalesStageColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Sales Stage",
  field: "salesStage",
};

const TypeColumn: AgColDefsI = {
  ...commonProperties100Width,
  headerName: "Type",
  field: "type",
};

const AddressTypeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Address Type",
  field: "type",
};

const SICDescriptionColumn: AgColDefsI = {
  ...commonProperties100Width,
  headerName: "SIC Description",
  field: "sicDescription",
};

const NAICSCodeColumn: AgColDefsI = {
  ...commonProperties100Width,
  headerName: "NAICS Code",
  field: "naics",
};

const NAICSYearColumn: AgColDefsI = {
  ...commonProperties100Width,
  headerName: "NAICS Year",
  field: "naicsYear",
};

const NAICSDescriptionColumn: AgColDefsI = {
  ...commonProperties100Width,
  headerName: "NAICS Description",
  field: "naicsDescription",
};

const EntityTypeColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Entity Type",
  field: "entityType",
};

const TimezoneColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Timezone",
  field: "timezone",
};

const CountryColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Country",
  field: "country",
};

const CompanyPhoneNoColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Company Phone Number",
  field: "companyPhoneNumber",
};

const CompanyEmailColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Company Email Address",
  field: "companyEmailAddress",
};

const CompanyFaxColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Company Fax Address",
  field: "companyFaxNumber",
};

const CompanyTypeColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Company Type",
  field: "type",
};

const CompanyTimezoneColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Company Timezone",
  field: "timezone",
};

const CompanyStateColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Company State",
  field: "state",
};

const VendorStateColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Vendor State",
  field: "state",
};

const CompanyCountryColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Company Country",
  field: "country",
};

const PhoneNumberColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Phone Number",
  field: "phone",
};

const FaxNumberColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Fax Number",
  field: "fax",
};


const CurrencyColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Currency",
  field: "currency",
};


const DAndBNumberColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "D&B Number",
  field: "dnBNumber",
};

const TaxIdColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Tax ID",
  field: "taxId",
};

const TagsColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Tags",
  field: "tags",
};

const EmployeesColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Employees",
  field: "employees",
};

const NAICSColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "NAICS Code",
  field: "naics",
};

const ResellerIDColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Reseller ID",
  field: "resellerID",
};

const RevenueColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "Revenue",
  field: "revenue",
};

const SICColumn: AgColDefsI = {
  ...commonProperties150Width,
  headerName: "SIC Code",
  field: "sic",
};

const IndustryColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Industry",
  field: "industry",
};

const ResellerIDExpirationDateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Reseller ID Expiration Date",
  field: "resellerIDExpirationDate",
};

const DetailsNotesColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Details Notes",
  field: "detailsNotes",
};

const NotesColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Notes",
  field: "notes",
};

const VendorSpecialtyColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Vendor Specialty",
  field: "vendorSpecialty",
};


const WebsiteColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Website",
  field: "website",
};

const DescriptionColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Description",
  field: "description",
};

const ParentCompanyColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Parent Company",
  field: "parentCompany",
};

const ContactColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact",
  field: "contact",
};

const MFRColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "MFR",
  field: "mfr",
};

const QtyColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Qty",
  field: "qty",
};

const DateCodeYearColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Date Code Year",
  field: "dateCodeYear",
};

const DateCodeWeekColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Date Code Week",
  field: "dateCodeWeek",
};

const RoHSColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "RoHS",
  field: "roHS",
};

const ConditionColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Condition",
  field: "condition",
};

const COOColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "COO",
  field: "coo",
};

const RequirementSourceColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Req Source",
  field: "requirementSource",
};

const CustomerNotesColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Customer Notes",
  field: "customerNotes",
};

const CustomerRFQColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Customer RFQ No.",
  field: "customerRFQ",
};

const MPNColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "MPN",
  field: "mpn",
};

const PriorityColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Priority",
  field: "priority",
};

const RequirementDateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Requirement Date",
  field: "requirementDate",
};

const CustomerPNColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Customer PN",
  field: "customerPN",
};

const NSNColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "NSN",
  field: "nsn",
};

const ItemPackageColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Item Pkg",
  field: "itemPkg",
};

const RevisionColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Revision",
  field: "revision",
};

const TestingColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Testing",
  field: "testing",
};

const CustomerTargetColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Customer target",
  field: "customerTarget",
};

const ExchangeRateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Exchange Rate",
  field: "exchangeRate",
};

const ConvertedTargetColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Converted Target",
  field: "convertedTarget",
};

const TargetBuyPriceColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Target Buy Price",
  field: "targetBuyPrice",
};

const NeedDateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Need Date",
  field: "needDate",
};

const EstStartDateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Est Start Date",
  field: "estStartDate",
};

const BidDeadlineColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Bid Deadline",
  field: "bidDeadline",
};

const EndCustomerColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "End Customer",
  field: "endCustomer",
};

const ProjectNameColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Project Name",
  field: "projectName",
};

const CloseProbabilityColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Close Probability",
  field: "closeProbability",
};

const ApplicationColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Application",
  field: "application",
};

const OpportunityNotesColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Opportunity Notes",
  field: "opportunityNotes",
};

const OpportunityTypeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Opportunity Type",
  field: "opportunityTypeId",
};

const OpportunityBuyTypeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Opportunity Buy Type",
  field: "opportunityBuyTypeId",
};

const CompanyColumn: AgColDefsI = {
  ...commonPrimaryColorColumnProperties,
  headerName: "Company Name",
  field: "company",
};

const CompanyNameColumn: AgColDefsI = {
  ...commonPrimaryColorColumnProperties,
  headerName: "Company Name",
  field: "company",
};

const CityColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "City",
  field: "addressCity",
};

const PostalCodeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Postal Code",
  field: "postalCode",
};

const ScopeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Scope",
  field: "scope",
};

const AddressNameColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Address Name",
  field: "addressName",
};

const AddressCountryColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Address Country",
  field: "addressCountry",
};

const AddressPhoneColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Address Phone Number",
  field: "addressPhoneNumber",
};

const AddressLine1Column: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Address Line 1",
  field: "addressLine1",
};

const AddressLine2Column: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Address Line 2",
  field: "addressLine2",
};

const MarkDefaultTypeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Mark as default for Type",
  field: "markasdefaultforType",
};

const AddressStateColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Address State",
  field: "addressState",
};

const AddressVATColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Address VAT/RFC/CNPJ",
  field: "addressVAT",
};

const DetailsVATColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Details VAT/RFC/CNPJ",
  field: "detailsVAT",
};

const ContactFirstNameColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact First Name",
  field: "contactFirstName",
};

const ContactLastNameColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact Last Name",
  field: "contactLastName",
};

const TitleColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Title",
  field: "title",
};

const GenderColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Gender",
  field: "gender",
};

const DepartmentColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Department",
  field: "department",
};

const LocationColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Location",
  field: "location",
};

const ContactTimezoneColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact Timezone",
  field: "contactTimezone",
};

const ContactEmailColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact Email",
  field: "contactEmail",
};

const MainOfficeNumberColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Main Office Number + Ext",
  field: "mainOfficeNumber",
};

const ContactDirectNumberColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact Direct Number",
  field: "contactDirectNumber",
};

const ContactMobileNumberColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact Mobile Number",
  field: "contactMobileNumber",
};

const ContactFaxNumberColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact Fax Number",
  field: "contactFaxNumber",
};

const SkypeColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Skype",
  field: "skype",
};

const XingColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Xing",
  field: "xing",
};

const LinkedInColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "LinkedIn",
  field: "linkedIn",
};

const ContactNotesColumn: AgColDefsI = {
  ...commonProperties200Width,
  headerName: "Contact Notes",
  field: "contactNotes",
};

const VendorNameColumn: AgColDefsI = {
  ...commonPrimaryColorColumnProperties,
  headerName: "Vendor Name",
  field: "company",
};

const ProjectApprovedColumn: AgColDefsI = {
  ...commonColumnProperties,
  headerName: "Project Approved",
  field: "projectApproved",
  minWidth: 200,
  sortable: true,
  cellStyle: { 'padding-left': "22px", 'color': '#646E76' },
  cellRenderer: (params: any) => params.value === true ? 'Yes' : params.value === false ? 'No' : "&#8212",
};

const EmailAddressColumn: AgColDefsI = {
  ...commonColumnProperties,
  headerName: "Email Address",
  field: "email",
  minWidth: 300,
  sortable: true,
  cellStyle: { 'padding-left': "22px", 'color': '#646E76' },
  cellRenderer: (params: any) => params.value ? params.value : "&#8212",
};

export enum ColumnName {
  COMPANY = 'company',
  STAGE = 'stage',
  SIC = 'sic',
  EMAIL = 'email',
  PHONE = 'phone',
  FAX = 'fax',
  INDUSTRY = 'industry',
  EMPLOYEE = 'employees',
  NAICS = 'naics',
  DONOTCALL = 'doNotCall',
  DATECONTACTED = 'dateContacted',
  CURRENCY = 'currency',
  ALT_SALESPERSON = 'alternateSalesperson',
  ACCOUNTING_CONTACT = 'accountingContact',
  ACTIVE = 'active',
  ACCOUNT_NUMBER = 'accountNumber',
  COUNTRY = 'country',
  STATE = 'state',
  COMPANY_RATING = 'companyRating',
  RECENT_NOTES = 'recentNotes',
  REVENUE = 'revenue',
  SALESPERSON = 'salesperson',
  SOURCING_EMAIL = 'sourcingEmail',
  TIME_ZONE = 'timezone',
  TYPE = 'type',
  WEBSITE = 'website',
}

export const CompanyColDefs: AgColDefsI[] = [
  svgColumn,
  CompanyNameColumn,
  SalesStageColumn,
  CompanyPhoneNoColumn,
  CompanyEmailColumn,
  CompanyFaxColumn,
  CompanyTypeColumn,
  CompanyTimezoneColumn,
  CompanyStateColumn,
  CompanyCountryColumn,
  WebsiteColumn,
  RatingColumn,
  TagsColumn,
  AddressTypeColumn,
  AddressNameColumn,
  CityColumn,
  AddressCountryColumn,
  AddressPhoneColumn,
  PostalCodeColumn,
  AddressLine1Column,
  AddressLine2Column,
  MarkDefaultTypeColumn,
  AddressStateColumn,
  AddressVATColumn,
  ScopeColumn,
  DetailsVATColumn,
  SICColumn,
  NAICSColumn,
  ResellerIDColumn,
  ResellerIDExpirationDateColumn,
  DetailsNotesColumn,
  DAndBNumberColumn,
  IndustryColumn,
  EntityTypeColumn,
  EmployeesColumn,
  ParentCompanyColumn,
  CurrencyColumn,
  RevenueColumn,
  TaxIdColumn,
  ContactFirstNameColumn,
  ContactLastNameColumn,
  TitleColumn,
  GenderColumn,
  DepartmentColumn,
  LocationColumn,
  ContactTimezoneColumn,
  ContactEmailColumn,
  MainOfficeNumberColumn,
  ContactDirectNumberColumn,
  ContactMobileNumberColumn,
  ContactFaxNumberColumn,
  SkypeColumn,
  XingColumn,
  LinkedInColumn,
  ContactNotesColumn
];

export const VendorColDefs: AgColDefsI[] = [
  svgColumn,
  VendorNameColumn,
  EmailAddressColumn,
  PhoneNumberColumn,
  FaxNumberColumn,
  VendorStateColumn,
  CountryColumn,
  WebsiteColumn,
  TimezoneColumn,
  RatingColumn,
  TypeColumn,
  TagsColumn,
  AddressNameColumn,
  AddressTypeColumn,
  AddressStateColumn,
  AddressLine1Column,
  AddressLine2Column,
  AddressCountryColumn,
  CityColumn,
  AddressPhoneColumn,
  PostalCodeColumn,
  AddressVATColumn,
  DAndBNumberColumn,
  IndustryColumn,
  SICColumn,
  NAICSColumn,
  ScopeColumn,
  DetailsVATColumn,
  EntityTypeColumn,
  EmployeesColumn,
  ParentCompanyColumn,
  CurrencyColumn,
  TaxIdColumn,
  ResellerIDColumn,
  ResellerIDExpirationDateColumn,
  VendorSpecialtyColumn, // field not match
  NotesColumn, // field not match
  ContactFirstNameColumn, // field not match
  ContactLastNameColumn, // field not match
  TitleColumn, // field not match
  GenderColumn, // field not match
  DepartmentColumn, // field not match
  LocationColumn, // field not match
  ContactTimezoneColumn, // field not match
  ContactEmailColumn, // field not match
  MainOfficeNumberColumn, // field not match
  ContactDirectNumberColumn, // field not match
  ContactMobileNumberColumn, // field not match
  ContactFaxNumberColumn, // field not match
  SkypeColumn, // field not match
  XingColumn, // field not match
  LinkedInColumn, // field not match
  ContactNotesColumn // field not match
];

export const RequirementColDefs: AgColDefsI[] = [
  svgColumn,
  CompanyColumn,
  ContactColumn,
  RequirementSourceColumn,
  CustomerNotesColumn,
  CustomerRFQColumn,
  PriorityColumn,
  RequirementDateColumn,
  MPNColumn,
  MFRColumn,
  QtyColumn,
  DateCodeYearColumn,
  DateCodeWeekColumn,
  CustomerPNColumn,
  NSNColumn,
  RoHSColumn,
  ConditionColumn,
  ItemPackageColumn,
  DescriptionColumn,
  RevisionColumn,
  COOColumn,
  TestingColumn,
  CustomerTargetColumn,
  CurrencyColumn,
  ExchangeRateColumn,
  ConvertedTargetColumn,
  TargetBuyPriceColumn,
  NeedDateColumn,
  OpportunityTypeColumn,
  ProjectApprovedColumn,
  EstStartDateColumn,
  BidDeadlineColumn,
  EndCustomerColumn,
  ProjectNameColumn,
  CloseProbabilityColumn,
  ApplicationColumn,
  OpportunityNotesColumn,
  OpportunityBuyTypeColumn
];

export const CodeCrosswalkColDefs: AgColDefsI[] = [
  svgColumn,
  SICColumn, // SIC Code
  SICDescriptionColumn, // SIC Description
  NAICSCodeColumn, // NAICS Code
  NAICSYearColumn, // NAICS Year
  NAICSDescriptionColumn, // NAICS Description
  IndustryColumn // Industry
]

export const AgGridImportCompaniesPreview: AgGridI = {
  colDefs: CompanyColDefs,
  rowSelection: "multiple",
};

export const AgGridImportVendorPreview: AgGridI = {
  colDefs: VendorColDefs,
  rowSelection: "multiple",
};

export const AgGridImportBOMPreview: AgGridI = {
  colDefs: RequirementColDefs,
  rowSelection: "multiple",
};

export const AgGridImportCodecrosswalkPreview: AgGridI = {
  colDefs: CodeCrosswalkColDefs,
  rowSelection: "multiple",
};